import script from "./TransactionPaymentContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./TransactionPaymentContent.vue?vue&type=script&lang=ts&setup=true"

import "./TransactionPaymentContent.vue?vue&type=style&index=0&id=4d68af79&lang=scss"

const __exports__ = script;

export default __exports__